import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { /* compressToBase64, */ decompressFromBase64 } from 'lz-string';

import { AppSyncClientCreate } from '../../../backends/AppSyncClientCreate';
import GetMyEndpoint from '../../../q/create/GetMyEndpoint';
import ChangeAppManualLegs from '../../../q/create/ChangeAppManualLegs';
import GetMyApp from '../../../q/create/GetMyApp';
import GetMyApps from '../../../q/create/GetMyApps';
import Endpoint from '../../../modules/data/Endpoint';
import App from '../../../modules/data/App';
import PublisherLegForm from '../../../components/forms/app/Leg';
import AORTypes from '../../../types';

class PublisherLegEdit extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherLegEdit';

    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onCancel() {
    const { history, endpoint } = this.props;
    history.push(`/editapp/${endpoint.data.app}/3`);
  }

  async onSave(values) {
    const {
      app,
      history, onSave,
      getAnalyticsService,
    } = this.props;

    getAnalyticsService().report.event('legSaveAttempt', 'create');

    app.postProcess();
    app.pp.legsManual = JSON.parse(decompressFromBase64(values.legsManual));
    // app.data.legsManual = compressToBase64(JSON.stringify(app.pp.legsManual));
    app.data.legsManual = values.legsManual;

    return onSave({
      uuid: app.data.uuid,
      legsManual: values.legsManual,
    }).then((_result) => {
      getAnalyticsService().report.event('legSaveSuccess', 'create');
      history.push(`/editapp/${app.data.uuid}/3`);

      return null;
    });
  }

  render() {
    const {
      app,
      endpoint,
      direction,
      match: { params: { index } },
      position,
      user,
      getDirectionsService,
      getAnalyticsService,
    } = this.props;

    if (!user) {
      return (
        <>
        </>
      );
    }

    return (
      <PublisherLegForm
        app={app}
        endpoint={endpoint}
        position={position}
        index={index}
        onCancel={this.onCancel}
        onNext={this.onCancel}
        onSave={this.onSave}
        direction={direction}
        getDirectionsService={getDirectionsService}
        getAnalyticsService={getAnalyticsService}
      />
    );
  }
}

PublisherLegEdit.defaultProps = {
  position: null, // it's unset until it's autodetected
  user: null,
};

PublisherLegEdit.propTypes = {
  app: PropTypes.instanceOf(App).isRequired,
  endpoint: PropTypes.instanceOf(Endpoint).isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  onSave: PropTypes.func.isRequired,
  position: AORTypes.Position,
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
  getDirectionsService: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetMyApp, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    // skip: (props) => !props.data || !props.data.getMyApps,
    props: (props) => {
      // console.log('graphql props');
      // console.log(props);
      const app = App.createFromData(props.data.getMyApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        onRefresh: props.data.refetch,
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.appUuid,
      },
      client: AppSyncClientCreate(props.user),
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only', // make sure to get the latest as lambda functions do change them
    }),
    // client: AppSyncClientCreate,
  }),
  graphql(GetMyEndpoint, {
    // skip: (props) => !props.data || !props.data.getMyEndpoint,
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      // console.log('graphql props');
      // console.log(props);
      const endpoint = Endpoint.createFromData(props.data.getMyEndpoint);
      return {
        onRefreshEndpoint: props.data.refetch,
        endpoint,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientCreate(props.user),
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only', // make sure to get the latest as lambda functions do change them
    }),
    // client: AppSyncClientCreate,
  }),
  graphql(ChangeAppManualLegs, {
    props: (props) => ({
      onSave: (input) => props.mutate({
        variables: input,
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApp,
        variables: { uuid: props.match.params.appUuid },
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyApps,
        client: AppSyncClientCreate(props.user),
      }, {
        query: GetMyEndpoint,
        props: (p) => ({
          endpoint: Endpoint.createFromData(p.data.getMyEndpoint),
        }),
        variables: { uuid: props.match.params.uuid },
        client: AppSyncClientCreate(props.user),
      }],
      // fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'no-cache',
      client: AppSyncClientCreate(props.user),
    }),
    // client: AppSyncClientCreate,
  })
)(PublisherLegEdit);
